// Shared by both forks.
import React, { createContext, useContext } from 'react';

// The old fork (old Spotlight) has no hybrid search, so it provides `false` for those.
export type SearchModeContextValue = {
	canUseSimilaritySearch: boolean;
	isNLSSearchOn: boolean;
	setIsNLSSearchOn: React.Dispatch<React.SetStateAction<boolean>>;
	isPerformingNLSSearch: boolean;
	isHybridSearchEnabled: boolean;
	isHybridSearchOn: boolean;
	isDropdownSearchDisabled: boolean;
	isSearchOptionsDisabled: boolean;
};

export const SearchModeContext = createContext<SearchModeContextValue | null>(null);

export function useSearchMode() {
	const context = useContext(SearchModeContext);

	if (!context) {
		throw new Error('useSearchMode must be used within a SpotlightStateProvider');
	}

	return context;
}
